export const LEGACY_SURVEY_PAGES = ['abstimmungen', 'konsultation', 'konsensuskonferenz']
export const PAGE_ACTIONS = {
  'abstimmungen-analytics': ['results'],
  abstimmungen: ['create', 'edit', 'invite', 'results', 'delete'],
  'leitlinien-umfragen': ['create', 'edit', 'results', 'delete'],
  feedback: ['edit', 'results'],
  konsultation: ['create', 'edit', 'invite', 'results', 'delete'],
  abfragen: ['edit', 'invite', 'results', 'delete'],
  authors: ['results'],
  fragenvorlagen: ['create', 'edit', 'delete'],
  konsensuskonferenz: ['create', 'edit', 'invite', 'results', 'delete'],
}
export const SURVEY_PAGES = Object.keys(PAGE_ACTIONS)

// Version 3 adds granular controls to the other Umfragen pages. Existing page
// grants keep their prior meaning until explicitly saved with the new controls.
export function effectiveSurveyAccess(permissions, page) {
  const configured = permissions?.survey_access?.[page]
  if (configured) return configured
  if (LEGACY_SURVEY_PAGES.includes(page) || !PAGE_ACTIONS[page] || Number(permissions?.version || 0) >= 3) return null
  const actions = Object.fromEntries(PAGE_ACTIONS[page].map(action => [action, true]))
  if (page === 'abfragen') actions.create = true // Legacy direct creation; new cards manage existing surveys only.
  let guidelines = 'all'
  if (['feedback', 'abstimmungen-analytics'].includes(page)) {
    const hasVotes = permissions?.pages === 'all' || (Array.isArray(permissions?.pages) && permissions.pages.includes('abstimmungen'))
    const votes = permissions?.survey_access?.abstimmungen
    guidelines = hasVotes ? (votes?.guidelines ?? (Number(permissions?.version || 0) >= 2 ? [] : permissions?.guidelines ?? 'all')) : []
    if (page === 'abstimmungen-analytics') {
      actions.results = !!hasVotes && (votes?.actions
        ? (Number(permissions?.version || 0) >= 2 ? votes.actions.results === true || votes.actions.export === true : votes.actions.results !== false)
        : votes?.access_level !== 'read' && Number(permissions?.version || 0) < 2)
    }
  }
  return { guidelines, actions }
}

export const SURVEY_ACTIONS = [
  { key: 'create', label: 'Erstellen' },
  { key: 'edit', label: 'Bearbeiten' },
  { key: 'invite', label: 'Einladen & erinnern' },
  { key: 'results', label: 'Ergebnisse ansehen' },
  { key: 'delete', label: 'Löschen' },
]

export const PAGE_CATEGORIES = [
  {
    title: 'Allgemein',
    items: [
      { key: 'activity', label: 'Nutzeraktivitäten' }
    ]
  },
  {
    title: 'Leitlinien',
    items: [
      { key: 'leitlinien', label: 'Gespeicherte Leitlinien' },
      { key: 'stageleitlinien', label: 'Stage Leitlinien' },
      { key: 'livearbeitsversionen', label: 'Live-Arbeitsversionen' }
    ]
  },
  {
    title: 'Umfragen',
    items: [
      { key: 'abstimmungen-analytics', label: 'Abstimmungs-Analytics', isSurvey: true },
      { key: 'abstimmungen', label: 'Abstimmungen (einschließlich Alte Abstimmungen)', isSurvey: true },
      { key: 'leitlinien-umfragen', label: 'Leitlinien-Umfragen', isSurvey: true },
      { key: 'feedback', label: 'Feedback', isSurvey: true },
      { key: 'konsultation', label: 'Konsultationen', isSurvey: true },
      { key: 'abfragen', label: 'Umfrage zum Updatebedarf', isSurvey: true },
      { key: 'authors', label: 'Autor*innen', isSurvey: true },
      { key: 'fragenvorlagen', label: 'Fragen-Vorlagen', isSurvey: true }
    ]
  },
  {
    title: 'Hub',
    items: [
      { key: 'hub-analytics', label: 'Hub Analytics' },
      { key: 'hub-leitlinien', label: 'Hub Leitlinien' }
    ]
  },
  {
    title: 'Mobile App',
    items: [
      { key: 'app-analytics', label: 'App-Analytics' },
      { key: 'app-benachrichtigungen', label: 'Push-Nachrichten' },
      { key: 'leitlinien-kommentare', label: 'Leitlinien-Kommentare' }
    ]
  },
  {
    title: 'Tools',
    items: [
      { key: 'newsletter', label: 'Newsletter' },
      { key: 'emailvorlagen', label: 'E-Mail Vorlagen' },
      { key: 'deepsearch', label: 'Deep Guidelines Search' },
      { key: 'fachgesellschaftengraph', label: 'Fachgesellschaften' },
      // 'backups' and 'errorsdisplay' are super-admin only — gated in
      // AdminSidebar.js by role, not via the per-page permission grid,
      // so they're intentionally absent here.
    ]
  }
]

export const ALL_PAGE_KEYS = PAGE_CATEGORIES.flatMap(c => c.items.map(i => i.key))

export const SURVEY_LABELS = {
  abstimmungen: 'Abstimmungen',
  konsultation: 'Konsultationen',
  konsensuskonferenz: 'Konsensuskonferenzen',
  'abstimmungen-analytics': 'Abstimmungs-Analytics',
  'leitlinien-umfragen': 'Leitlinien-Umfragen',
  feedback: 'Feedback',
  abfragen: 'Umfrage zum Updatebedarf',
  authors: 'Autor*innen',
  fragenvorlagen: 'Fragen-Vorlagen'
}
